import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'motion/react';
import EventImageSlideshow from './EventImageSlideshow';

const EventImageGallery = ({ photos, getImageUrl, eventId, onHelpful }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showSlideshow, setShowSlideshow] = useState(false);

  if (!photos || photos.length === 0) return null;

  // Sort photos by uploadedAt (newest first)
  const sortedPhotos = [...photos].sort((a, b) => {
    const dateA = new Date(a.uploadedAt || 0);
    const dateB = new Date(b.uploadedAt || 0);
    return dateB - dateA;
  });

  // Show max 6 images in grid (2 rows x 3 columns)
  const maxVisible = 6;
  const visiblePhotos = sortedPhotos.slice(0, maxVisible);
  const remainingCount = sortedPhotos.length - maxVisible;

  const handleImageClick = (index) => {
    setSelectedIndex(index);
    setShowSlideshow(true);
  };

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 0.5,
          mb: 3,
          borderRadius: 1,
          overflow: 'hidden'
        }}
      >
        {visiblePhotos.map((photo, index) => {
          const isLast = index === visiblePhotos.length - 1;
          const showOverlay = isLast && remainingCount > 0;

          return (
            <motion.div
              key={index}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              style={{ position: 'relative', aspectRatio: '1', cursor: 'pointer' }}
              onClick={() => handleImageClick(index)}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  overflow: 'hidden',
                  backgroundColor: '#f0f0f0'
                }}
              >
                <img
                  src={getImageUrl(photo.url)}
                  alt={`Photo ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
                {showOverlay && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 1
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: 'white',
                        fontWeight: 600,
                        textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                      }}
                    >
                      +{remainingCount}
                    </Typography>
                  </Box>
                )}
              </Box>
            </motion.div>
          );
        })}
      </Box>

      {showSlideshow && (
        <EventImageSlideshow
          photos={sortedPhotos}
          initialIndex={selectedIndex}
          getImageUrl={getImageUrl}
          eventId={eventId}
          onHelpful={onHelpful}
          onClose={() => {
            setShowSlideshow(false);
            setSelectedIndex(null);
          }}
        />
      )}
    </>
  );
};

export default EventImageGallery;

